import { Provider } from '@angular/compiler/src/core';
import {
    APP_BOOTSTRAP_LISTENER,
    APP_INITIALIZER,
} from '@angular/core';
import { AppStateFacade } from '@app-state';
import { IconService } from '@services';
import CustomDateLocales from '@utils/custom-date-locales';

import { PageMetadataRegistry } from 'main/router';
import * as moment from 'moment';

export function initializer(
    appState: AppStateFacade,
    _iconService: IconService,
) {
    // Extend standard moment.js locales with custom settings.
    for (const locale of Object.keys(CustomDateLocales)) {
        moment.updateLocale(locale, CustomDateLocales[locale]);
    }

    return async () => {
        try {
            await appState.initialize().toPromise();

            if (
                appState.authConfig.value.isTelemetryEnabled &&
                !!(window as any)['mixpanel']
            ) {
                (window as any)['mixpanel'].init(appState.authConfig.value.mixpanelKey, { track_pageview: false });
            }
        } catch (error) {
            error.isSeed = true;
            throw error;
        }
    };
}

export const UIPATH_INITIALIZER: Provider = {
    provide: APP_INITIALIZER,
    useFactory: initializer,
    deps: [
        AppStateFacade,
        IconService,
    ],
    multi: true,
};


export function bootstrapListener(
    pageRegistry: PageMetadataRegistry,
) {
    return () => {
        pageRegistry.listen();
    };
}

export const UIPATH_BOOTSTRAP_LISTENER: Provider = {
    provide: APP_BOOTSTRAP_LISTENER,
    useFactory: bootstrapListener,
    deps: [PageMetadataRegistry],
    multi: true,
};
